var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgResizeBottomRight = function SvgResizeBottomRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#90A9C0",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 11.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 11.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 6.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 1.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 1.5
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgResizeBottomRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/resize_bottom_right.eced93cf.svg";
export { ForwardRef as ReactComponent };